import { render, staticRenderFns } from "./score-update.vue?vue&type=template&id=635626b8&"
import script from "./score-update.vue?vue&type=script&lang=js&"
export * from "./score-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports